export { AstarNode };
/**
 * Implements a simple node for A* search
 * Wrapper for node cost and previous pointer
 */
class AstarNode {
    /**
     * @param {AstarNode} previous - reference to the parent/predecessor
     * @param {Node2D} node - the geomtric node (point + direction)
     * @param {number} cost - accumulated cost of this node
     */
    constructor(previous, node, cost) {
        this.previous = previous;
        this.node = node;
        this.cost = cost;
    }
    getPath() {
        const nodes = [];
        let current = this;
        do {
            nodes.push(current);
            current = current.previous;
        } while (current !== undefined);
        nodes.reverse();
        return nodes;
    }
    getNodes() {
        return this.getPath().map(n => n.node);
    }
}
//# sourceMappingURL=AstarNode.js.map